export default "__VITE_ASSET__DXfToGpU__"